import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import "../css/Sidebar.css";
import {
  LayoutDashboard,
  Users,
  GraduationCap,
  BookOpen,
  Calendar,
  LineChart,
  FileText,
  Settings,
  ChevronRight,
  ChevronDown,
  Library,
  Clock,
  Award,
  Bus,
  Home,
  MessageSquare,
  X,
  Contact,
  Wallet
} from 'lucide-react';
import { jwtDecode } from 'jwt-decode';




function Sidebar({ collapsed, isMobile, mobileOpen }) {
  const location = useLocation();
  const [expandedItems, setExpandedItems] = useState(['admin']);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setUserRole(decodedToken.role); // Extract role from token
      } catch (error) {
        console.error("Invalid token:", error);
        localStorage.removeItem('token'); // Remove invalid token
      }
    }
  }, []);


  const toggleExpand = (item) => {
    if (expandedItems.includes(item)) {
      setExpandedItems(expandedItems.filter(i => i !== item));
    } else {
      setExpandedItems([...expandedItems, item]);
    }
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const menuItems = [
    // admin pages
    { id: 'dashboard', label: 'Dashboard', icon: <LayoutDashboard size={20} />, path: '/dashboard', roles: ['admin'] },
    {
      id: 'admin',
      label: 'Admin',
      icon: <Users size={20} />,
      hasSubmenu: true,
      roles: ['admin'],
      submenu: [
        { id: 'admin-profile', label: 'Profile', path: '/admin/profile' },
        // { id: 'admin-settings', label: 'Settings', path: '/admin/settings' }
      ]
    },
    {
      id: 'students',
      label: 'Students',
      icon: <GraduationCap size={20} />,
      hasSubmenu: true,
      roles: ['admin'],
      submenu: [
        { id: 'student-list', label: 'All Students', path: '/students' },
        { id: 'student-add', label: 'Add Student', path: '/students/add' }
      ]
    },
    {
      id: 'teachers',
      label: 'Teachers',
      roles: ['admin'],
      icon: <Users size={20} />,
      hasSubmenu: true,
      submenu: [
        { id: 'teacher-list', label: 'All Teachers', path: '/teachers' },
        { id: 'teacher-add', label: 'Add Teacher', path: '/teachers/add' }
      ]
    },
    {
      id: 'parents',
      label: 'Parents',
      roles: ['admin'],
      icon: <Users size={20} />,
      hasSubmenu: true,
      submenu: [
        { id: 'parent-list', label: 'All Parents', path: '/parents' },
        { id: 'parent-add', label: 'Add Parent', path: '/parents/add' }
      ]
    },
    {
      id: 'library',
      label: 'Library',
      roles: ['admin'],
      icon: <Library size={20} />,
      hasSubmenu: true,
      submenu: [
        { id: 'books', label: 'Books', path: '/library/books' },
        { id: 'issue-return', label: 'Issue/Return', path: '/library/issue-return' }
      ]
    },
    {
      id: 'class',
      label: 'Class',
      roles: ['admin'],
      icon: <BookOpen size={20} />,
      hasSubmenu: true,
      submenu: [
        { id: 'class-list', label: 'All Classes', path: '/classes' },
        { id: 'class-add', label: 'Add Class', path: '/classes/add' }
      ]
    },
    {
      id: 'subjects',
      label: 'Subjects',
      roles: ['admin'],
      icon: <FileText size={20} />,
      hasSubmenu: true,
      submenu: [
        { id: 'subject-list', label: 'All Subjects', path: '/subjects' },
        { id: 'subject-add', label: 'Add Subject', path: '/subjects/add' }
      ]
    },
    {
      id: 'routine',
      label: 'Class Routine',
      icon: <Clock size={20} />,
      hasSubmenu: true,
      roles: ['admin'],
      submenu: [
        { id: 'routine-view', label: 'View Routine', path: '/routine' },
        { id: 'routine-create', label: 'Create Routine', path: '/routine/create' }
      ]
    },
    {
      id: 'attendance',
      label: 'Attendance',
      icon: <Calendar size={20} />,
      hasSubmenu: true,
      roles: ['admin'],
      submenu: [
        { id: 'attendance-take', label: 'Take Attendance', path: '/attendance/take' },
        { id: 'attendance-view', label: 'View Attendance', path: '/attendance/view' }
      ]
    },
    {
      id: 'exam',
      label: 'Exam',
      icon: <Award size={20} />,
      hasSubmenu: true,
      roles: ['admin'],
      submenu: [
        { id: 'exam-schedule', label: 'Exam Schedule', path: '/exam/schedule' },
        { id: 'exam-grades', label: 'Grades', path: '/exam/grades' }
      ]
    },
    {
      id: 'transport',
      label: 'Transport',
      icon: <Bus size={20} />,
      hasSubmenu: true,
      roles: ['admin'],
      submenu: [
        { id: 'transport-routes', label: 'Routes', path: '/transport/routes' },
        { id: 'transport-vehicles', label: 'Vehicles', path: '/transport/vehicles' }
      ]
    },
    {
      id: 'hostel',
      label: 'Hostel',
      icon: <Home size={20} />,
      hasSubmenu: true,
      roles: ['admin'],
      submenu: [
        { id: 'hostel-rooms', label: 'Rooms', path: '/hostel/rooms' },
        { id: 'hostel-students', label: 'Students', path: '/hostel/students' }
      ]
    },
    {
      id: 'Payroll',
      label: 'Payroll',
      icon: <Wallet size={20} />,
      hasSubmenu: true,
      roles: ['admin'],
      submenu: [
        { id: 'payroll-student', label: 'Student Payment', path: '/payroll/payment' },
        { id: 'payroll-history', label: 'Payment Records', path: '/payroll/records' }
      ]
    },
    {
      id: 'IdCard',
      label: 'ID Card',
      icon: <Contact
        size={20} />,
      hasSubmenu: true,
      roles: ['admin'],
      submenu: [
        { id: 'view-idCards', label: 'Id Cards', path: '/id-cards' },
        { id: 'generate-idCards', label: 'Generate Cards', path: '/generate-idCards' }
      ]
    },
    {
      id: 'notice',
      label: 'Notice',
      icon: <MessageSquare size={20} />,
      hasSubmenu: true,
      roles: ['admin'],
      submenu: [
        { id: 'notice-list', label: 'All Notices', path: '/notices' },
        { id: 'notice-add', label: 'Add Notice', path: '/notices/add' }
      ]
    },
    { id: 'reports', label: 'Reports', icon: <LineChart size={20} />, path: '/reports', roles: ['admin'] },
    // { id: 'settings', label: 'Settings', icon: <Settings size={20} />, path: '/settings', roles: ['admin'] }


    // Teacher pages

    { id: 'dashboard', label: 'Dashboard', icon: <LayoutDashboard size={20} />, path: '/dashboard/teacher', roles: ['teacher'] },
    {
      id: 'teacher',
      label: 'Teacher',
      icon: <Users size={20} />,
      hasSubmenu: true,
      roles: ['teacher'],
      submenu: [
        { id: 'teacher-profile', label: 'Profile', path: '/teacher/profile' },
        // { id: 'admin-settings', label: 'Settings', path: '/admin/settings' }
      ]
    },
    { id: 'students', label: 'All Students', icon: <GraduationCap size={20} />, path: '/teacher/allStudents', roles: ['teacher'] },
    { id: 'parents', label: 'All Parents', icon: <Users size={20} />, path: '/teacher/allParents', roles: ['teacher'] },
    { id: 'class', label: 'All Classes', icon: <BookOpen size={20} />, path: '/teacher/classes', roles: ['teacher'] },
    { id: 'routine', label: 'View Routine', icon: <Clock size={20} />, path: '/teacher/routine', roles: ['teacher'] },
    { id: 'attendance', label: 'Attendance', icon: <Calendar size={20} />, path: '/teacher/attendance', roles: ['teacher'] },
    { id: 'exam', label: 'Exam Schedule', icon: <Award size={20} />, path: '/teacher/exam/schedule', roles: ['teacher'] },
    { id: 'notice', label: 'Notice & Events', icon: <MessageSquare size={20} />, path: '/teacher/notices', roles: ['teacher'] },
    {
      id: 'reports',
      label: 'Reports',
      icon: <LineChart size={20} />,
      hasSubmenu: true,
      roles: ['teacher'],
      submenu: [
        { id: 'report', label: 'Report', path: '/teacher/report' },
        { id: 'reports', label: 'View Reports', path: '/teacher/reports' }
      ]
    },

    // students and Guardian pages


    { id: 'dashboard', label: 'Dashboard', icon: <LayoutDashboard size={20} />, path: '/student/dashboard', roles: ['student'] },
    {
      id: 'student',
      label: 'Student',
      icon: <Users size={20} />,
      hasSubmenu: true,
      roles: ['student'],
      submenu: [
        { id: 'student-profile', label: 'Profile', path: '/student/profile' },
      ]
    },
    { id: 'class', label: 'All Classes', icon: <BookOpen size={20} />, path: '/student/classes', roles: ['student'] },
    { id: 'routine', label: 'View Routine', icon: <Clock size={20} />, path: '/student/routine', roles: ['student'] },
    { id: 'attendance', label: 'Attendance', icon: <Calendar size={20} />, path: '/student/attendance', roles: ['student'] },
    { id: 'exam', label: 'Exam Schedule', icon: <Award size={20} />, path: '/student/exam/schedule', roles: ['student'] },
    { id: 'notice', label: 'Notice & Events', icon: <MessageSquare size={20} />, path: '/student/notices', roles: ['student'] },
    {
      id: 'reports',
      label: 'Reports',
      icon: <LineChart size={20} />,
      hasSubmenu: true,
      roles: ['student'],
      submenu: [
        { id: 'report', label: 'Report', path: '/student/report' },
        { id: 'reports', label: 'View Reports', path: '/student/reports' }
      ]
    },
  ];

  const filteredMenuItems = menuItems.filter(item => item.roles?.includes(userRole));



  const sidebarClass = isMobile
    ? `sidebar mobile ${mobileOpen ? 'open' : ''}`
    : `sidebar ${collapsed ? 'collapsed' : ''}`;

  return (
    <div className={sidebarClass}>
      <div className="sidebar-header">
        {isMobile && mobileOpen && (
          <button className="close-sidebar">
            <X size={20} />
          </button>
        )}
        <div className="sidebar-logo">
          <div className="logo-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 7L12 12L22 7L12 2Z" fill="#FFD700" stroke="#FFD700" strokeWidth="2" />
              <path d="M5 9V16L12 20L19 16V9" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </div>
          {(!collapsed || (isMobile && mobileOpen)) && <span className="logo-text">EduManage</span>}
        </div>
      </div>

      <div className="sidebar-content">
        <nav className="sidebar-menu">
          <ul>
            {filteredMenuItems.map((item) => (
              <li key={item.id} className={`menu-item ${item.path && isActive(item.path) ? 'active' : ''}`}>
                {item.path ? (
                  <Link to={item.path} className="menu-item-header">
                    <div className="menu-item-icon">{item.icon}</div>
                    {(!collapsed || (isMobile && mobileOpen)) && (
                      <div className="menu-item-label">{item.label}</div>
                    )}
                  </Link>
                ) : (
                  <div
                    className="menu-item-header"
                    onClick={() => {
                      if (item.hasSubmenu) {
                        toggleExpand(item.id);
                      }
                    }}
                  >
                    <div className="menu-item-icon">{item.icon}</div>
                    {(!collapsed || (isMobile && mobileOpen)) && (
                      <>
                        <div className="menu-item-label">{item.label}</div>
                        {item.hasSubmenu && (
                          <div className="menu-item-arrow">
                            {expandedItems.includes(item.id) ?
                              <ChevronDown size={16} /> :
                              <ChevronRight size={16} />
                            }
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )}

                {(!collapsed || (isMobile && mobileOpen)) && item.hasSubmenu && expandedItems.includes(item.id) && (
                  <ul className="submenu">
                    {item.submenu.map((subItem) => (
                      <li
                        key={subItem.id}
                        className={`submenu-item ${isActive(subItem.path) ? 'active' : ''}`}
                      >
                        <Link to={subItem.path}>{subItem.label}</Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default Sidebar;